module.exports = __webpack_public_path__ + "img/job-medium.0c7f9352.svg";